import { ControlError } from "./parse.ts";

export type InstallerFileName = string & { readonly brand: "WyloInstallerFileName" };

export type InstallerEnvironment = "test" | "prod";

const VERSION = /^(0|[1-9][0-9]*)\.(0|[1-9][0-9]*)\.(0|[1-9][0-9]*)$/;

const DISPOSITION =
  /^attachment; filename="(Wylo\.RC\.Agent\.(test|prod)\.(0|[1-9][0-9]*)\.(0|[1-9][0-9]*)\.(0|[1-9][0-9]*)\.msi)"$/;

export function formatInstallerSaveName(
  environment: InstallerEnvironment,
  version: string,
): InstallerFileName {
  if ((environment !== "test" && environment !== "prod") || !VERSION.test(version)) {
    throw rejected();
  }
  return brand(`Wylo.RC.Agent.${environment}.${version}.msi`);
}

export function parseInstallerDisposition(header: string | null): InstallerFileName {
  if (header === null || header.length === 0) {
    throw rejected();
  }
  const match = DISPOSITION.exec(header);
  if (match === null) {
    throw rejected();
  }
  return brand(match[1]);
}

function brand(fileName: string): InstallerFileName {
  return fileName as InstallerFileName;
}

function rejected(): ControlError {
  return new ControlError({
    type: "urn:wylo-rc:error:agent-installer",
    title: "Could not download the agent",
    status: 502,
  });
}
